export var DatePattern;
(function (DatePattern) {
    DatePattern[DatePattern["YYYY_MM_DD"] = 0] = "YYYY_MM_DD";
    DatePattern[DatePattern["YYYY_MM_DD_HH_mm_ss"] = 1] = "YYYY_MM_DD_HH_mm_ss";
    DatePattern[DatePattern["DD_MM_YYYY"] = 2] = "DD_MM_YYYY";
    DatePattern[DatePattern["DD_MM_YYYY_HH_mm_ss"] = 3] = "DD_MM_YYYY_HH_mm_ss";
    DatePattern[DatePattern["yyyy-MM-dd_HH-mm-ss"] = 4] = "yyyy-MM-dd_HH-mm-ss";
    DatePattern[DatePattern["HH_mm_ss"] = 5] = "HH_mm_ss";
})(DatePattern || (DatePattern = {}));
export var MonthNames = [
    'Jan', 'Feb', 'Mar',
    'Apr', 'May', 'June',
    'July', 'Aug', 'Sept',
    'Oct', 'Nov', 'Dec'
];
function convertDateForNumericPatterns(year, month, day, hour, minutes, seconds) {
    var y = year.toString();
    var m = (month + 1).toString();
    var d = day.toString();
    var h = hour.toString();
    var min = minutes.toString();
    var sec = seconds.toString();
    if (m.length < 2) {
        m = "0".concat(m);
    }
    if (d.length < 2) {
        d = "0".concat(d);
    }
    if (h.length < 2) {
        h = "0".concat(h);
    }
    if (min.length < 2) {
        min = "0".concat(min);
    }
    if (sec.length < 2) {
        sec = "0".concat(sec);
    }
    return { y: y, m: m, d: d, h: h, min: min, sec: sec };
}
function makeResultFromPattern(year, month, day, hour, minutes, seconds, pattern) {
    var _a = convertDateForNumericPatterns(year, month, day, hour, minutes, seconds), y = _a.y, m = _a.m, d = _a.d, h = _a.h, min = _a.min, sec = _a.sec;
    switch (pattern) {
        case DatePattern.YYYY_MM_DD: {
            return [y, m, d].join('/');
        }
        case DatePattern.DD_MM_YYYY: {
            return [d, m, y].join('/');
        }
        case DatePattern.HH_mm_ss: {
            return [h, min, sec].join(':');
        }
        case DatePattern.YYYY_MM_DD_HH_mm_ss: {
            return "".concat([y, m, d].join('/'), " ").concat([h, min, sec].join(':'));
        }
        case DatePattern.DD_MM_YYYY_HH_mm_ss: {
            return "".concat([d, m, y].join('/'), " ").concat([h, min, sec].join(':'));
        }
        case DatePattern['yyyy-MM-dd_HH-mm-ss']: {
            return "".concat([year, MonthNames[month], day].join(' '), " ").concat([h, min, sec].join('-'));
        }
        default: {
            return [year, month, day].join('/');
        }
    }
}
export function formatUTCDate(date, pattern) {
    if (date === undefined) {
        return '';
    }
    var tempDate = typeof date === 'string' ? new Date(date) : date;
    var month = tempDate.getUTCMonth();
    var day = tempDate.getUTCDate();
    var year = tempDate.getUTCFullYear();
    var hour = tempDate.getUTCHours();
    var minutes = tempDate.getUTCMinutes();
    var seconds = tempDate.getUTCSeconds();
    return pattern ? makeResultFromPattern(year, month, day, hour, minutes, seconds, pattern) : tempDate.toUTCString();
}
export function formatDate(date, pattern) {
    if (date === null) {
        return '';
    }
    var tempDate = typeof date === 'string' ? new Date(date) : date;
    var month = tempDate.getMonth();
    var day = tempDate.getDate();
    var year = tempDate.getFullYear();
    var hour = tempDate.getHours();
    var minutes = tempDate.getMinutes();
    var seconds = tempDate.getSeconds();
    return pattern ? makeResultFromPattern(year, month, day, hour, minutes, seconds, pattern) : tempDate.toString();
}
export function getMonday(d, weeksAgo, hours, minutes, seconds) {
    if (weeksAgo === void 0) { weeksAgo = 0; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    var tempDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes, seconds, 0);
    var day = tempDate.getDay() + (weeksAgo > 0 ? 7 * weeksAgo : 0);
    var diff = tempDate.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(tempDate.setDate(diff));
}
export function getSunday(d, weeksAgo, hours, minutes, seconds) {
    if (weeksAgo === void 0) { weeksAgo = 0; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    var tempDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes, seconds, 0);
    var day = tempDate.getDay() + (weeksAgo > 0 ? 7 * weeksAgo : 0);
    var diff = (tempDate.getDate() - day + (day === 0 ? -6 : 1) + 6);
    return new Date(tempDate.setDate(diff));
}
export function getMonthStartDate(d, monthAgo, hours, minutes, seconds) {
    if (monthAgo === void 0) { monthAgo = 1; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    return new Date(d.getFullYear(), d.getMonth() - monthAgo, 1, hours, minutes, seconds);
}
export function getMonthEndDate(d, monthAgo, hours, minutes, seconds) {
    if (monthAgo === void 0) { monthAgo = 0; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    return new Date(d.getFullYear(), d.getMonth() - monthAgo, 0, hours, minutes, seconds);
}
export function getYearStartDate(d, yearsAgo, hours, minutes, seconds) {
    if (yearsAgo === void 0) { yearsAgo = 1; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    return new Date(d.getFullYear() - yearsAgo, 0, 1, hours, minutes, seconds);
}
export function getYearEndDate(d, yearsAgo, hours, minutes, seconds) {
    if (yearsAgo === void 0) { yearsAgo = 0; }
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    return new Date(d.getFullYear() - yearsAgo, 0, 0, hours, minutes, seconds);
}
export function coordinateTimeZone(serverOffset) {
    var clientOffset = new Date().getTimezoneOffset();
    return serverOffset === 0 ? clientOffset * 60000 : (clientOffset - serverOffset) * 60000;
}
export function convertOffsetToMs(serverOffset) {
    return serverOffset * 60000;
}
//# sourceMappingURL=times.js.map